import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { apiClient } from '../../config';

const AddPartner = () => {
  const [formData, setFormData] = useState({
    name: '',
    designation: '',
    companyName: '',
    contactNumber: '',
    email: '',
    linkedinProfile: '',
    location: '',
    partnerType: 'Mentor',
    industry: '',
    websiteUrl: '',
    description: '',
    imageUrl: null,
  });

  const [partners, setPartners] = useState([]);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    fetchPartners();
  }, []);

  const fetchPartners = async () => {
    try {
      const res = await apiClient.get('/api/partners');
      setPartners(res.data);
    } catch (err) {
      console.error('Error fetching partners:', err);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      imageUrl: e.target.files[0],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const partnerForm = new FormData();

    Object.keys(formData).forEach(key => {
        if (key === 'imageUrl' && formData[key] instanceof File) {
            partnerForm.append(key, formData[key]);
        } else if (formData[key]) { 
            partnerForm.append(key, formData[key]);
        }
    });

    try {
      setSubmitting(true);
      await apiClient.post('/api/partners', partnerForm, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      toast.success('Partner created successfully!');
      fetchPartners();

      setFormData({
        name: '', designation: '', companyName: '', contactNumber: '', email: '',
        linkedinProfile: '', location: '', partnerType: 'Mentor', industry: '',
        websiteUrl: '', description: '', imageUrl: null
      });
      e.target.reset();

    } catch (err) {
      console.error('Submit error:', err);
      const errorMessage = err.response?.data?.message || err.message || 'Partner submission failed';
      toast.error(errorMessage);
    } finally {
      setSubmitting(false);
    }
  };

  const handleDelete = async (partnerId) => {
    if (!window.confirm('Are you sure you want to delete this partner?')) return;
    
    try {
        await apiClient.delete(`/api/partners/${partnerId}`);
        toast.success('Partner deleted successfully!');
        fetchPartners();
    } catch (err) {
        console.error('Delete error:', err);
        toast.error('Failed to delete partner. Please try again.');
    }
  };

  return (
    <div className="container-fluid py-4">
      {/* Add Partner Form Card */}
      <div className="row my-4">
        <div className="col-12">
          <div className="card border-0 shadow-sm">
            <div className="card-header border-bottom bg-transparent py-3">
              <h5 className="mb-0 fw-semibold text-dark">Add New Partner</h5>
            </div>
            <div className="card-body p-4">
              <form className="row g-3" onSubmit={handleSubmit}>
                <div className="col-md-6">
                  <label className="form-label text-secondary">Partner Name *</label>
                  <input type="text" name="name" className="form-control" value={formData.name} onChange={handleChange} required />
                </div>
                 <div className="col-md-6">
                  <label className="form-label text-secondary">Email *</label>
                  <input type="email" name="email" className="form-control" value={formData.email} onChange={handleChange} required />
                </div>
                <div className="col-md-6">
                  <label className="form-label text-secondary">Designation</label>
                  <input type="text" name="designation" className="form-control" value={formData.designation} onChange={handleChange} />
                </div>
                <div className="col-md-6">
                  <label className="form-label text-secondary">Company Name</label>
                  <input type="text" name="companyName" className="form-control" value={formData.companyName} onChange={handleChange} />
                </div>
                <div className="col-md-6">
                  <label className="form-label text-secondary">Contact Number</label>
                  <input type="text" name="contactNumber" className="form-control" value={formData.contactNumber} onChange={handleChange} />
                </div>
                 <div className="col-md-6">
                  <label className="form-label text-secondary">Location</label>
                  <input type="text" name="location" className="form-control" value={formData.location} onChange={handleChange} />
                </div>
                <div className="col-md-6">
                    <label className="form-label text-secondary">Partner Type</label>
                    <select name="partnerType" className="form-select" value={formData.partnerType} onChange={handleChange}>
                        <option>Investor</option>
                        <option>Mentor</option>
                        <option>Legal</option>
                        <option>Other</option>
                    </select>
                </div>
                 <div className="col-md-6">
                    <label className="form-label text-secondary">Industry</label>
                    <input type="text" name="industry" className="form-control" value={formData.industry} onChange={handleChange} />
                </div>
                <div className="col-md-6">
                  <label className="form-label text-secondary">LinkedIn Profile URL</label>
                  <input type="url" name="linkedinProfile" className="form-control" value={formData.linkedinProfile} onChange={handleChange} />
                </div>
                <div className="col-md-6">
                  <label className="form-label text-secondary">Website URL</label>
                  <input type="url" name="websiteUrl" className="form-control" value={formData.websiteUrl} onChange={handleChange} />
                </div>
                <div className="col-12">
                  <label className="form-label text-secondary">Description</label>
                  <textarea name="description" className="form-control" rows="3" value={formData.description} onChange={handleChange} />
                </div>
                <div className="col-md-6">
                  <label className="form-label text-secondary">Upload Partner Image</label>
                  <input type="file" name="imageUrl" className="form-control" onChange={handleFileChange} />
                </div>
                <div className="col-md-6 d-flex align-items-end">
                  <button type="submit" className="btn btn-primary w-100 mt-2" disabled={submitting}>
                    {submitting ? 'Adding...' : 'Add Partner'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Partners Table Card */}
      <div className="row">
        <div className="col-12">
          <div className="card border-0 shadow-sm">
            <div className="card-header border-bottom bg-transparent py-3">
              <h5 className="mb-0 fw-semibold text-dark">Partner Details</h5>
            </div>
            <div className="card-body p-4 table-responsive">
              <table className="table table-striped align-middle">
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>Name</th>
                    <th>Company</th>
                    <th>Partner Type</th>
                    <th>Contact</th>
                    <th>Location</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {partners?.length > 0 ? (
                    partners.map((partner, i) => (
                      <tr key={partner._id}>
                        <td>{i + 1}</td>
                        <td className="fw-semibold text-dark">{partner.name}</td>
                        <td>{partner.companyName || '-'}</td>
                        <td>
                          <span className="badge bg-secondary text-capitalize">{partner.partnerType}</span>
                        </td>
                        <td>{partner.contactNumber || '-'}</td>
                        <td>{partner.location || '-'}</td>
                        <td>
                          <button onClick={() => handleDelete(partner._id)} className="btn btn-sm btn-outline-danger">Delete</button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center text-muted py-4">
                        No partners found. Add one using the form above.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPartner;

